import React from 'react';

import Textarea from '../../../components/Textarea';
import Dropzone from '../../../components/Dropzone';
import {
  BUTTON_LIGHT_MODAL_STYLE_BLOG,
  BUTTON_MODAL_STYLE_BLOG,
  COLORS,
  COMMENT_INTRODUCTION,
  PORTFOLIO_INTRO_LOGO_ASPECT_RATIO,
  TEXTAREA_DELAY,
  TITLE_MODAL_STYLE_BLOG,
} from '../../../utils/const';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';
import { getColorDependsOnBackground } from '../../../utils/helpers/getColorDependsOnBackground';

const { black } = COLORS;

const IntroductionBlog = ({
  data,
  locales,
  locales: { portfolio },
  onLogoDrop,
  onLogoCropComplete,
  onBgDrop,
  onBgCropComplete,
  handleDescriptionSubmit,
  handleInputSubmit,
  uploadingIntrologo,
  uploadingIntrobg,
  backgroundSection,
  backgroundModal,
  backgroundContent,
  isFourthColorPaletteNumber = false,
  disabled = false,
}) => {
  const {
    title,
    description,
    introLogo,
    introLogoCoords,
    introBg,
    introBgCoords,
  } = data;

  const textColorDependsOnBackground =
    isFourthColorPaletteNumber &&
    getColorDependsOnBackground(backgroundSection);

  return (
    <div
      className="introduction-blogFriendly-wrapper relative"
      style={{ backgroundColor: backgroundSection }}
    >
      <PortfolioCommentIcon title={COMMENT_INTRODUCTION} />
      <div className="logo-hover">
        <Dropzone
          className="logo-upload"
          onDrop={onLogoDrop}
          onCropperSave={onLogoCropComplete}
          locales={locales}
          image={introLogo}
          coords={introLogoCoords}
          aspectRatio={PORTFOLIO_INTRO_LOGO_ASPECT_RATIO}
          uploading={uploadingIntrologo}
          disabled={disabled}
          titleStyle={TITLE_MODAL_STYLE_BLOG}
          buttonStyle={BUTTON_MODAL_STYLE_BLOG}
          lightButtonStyle={BUTTON_LIGHT_MODAL_STYLE_BLOG}
          sliderColor={black}
          backgroundModal={backgroundModal}
          isTemplates
          cropper
        />
      </div>
      <div className="image-hover">
        <Dropzone
          className="image"
          background={{ backgroundColor: backgroundSection }}
          onDrop={onBgDrop}
          onCropperSave={onBgCropComplete}
          locales={locales}
          image={introBg}
          coords={introBgCoords}
          aspectRatio={1}
          uploading={uploadingIntrobg}
          disabled={disabled}
          titleStyle={TITLE_MODAL_STYLE_BLOG}
          buttonStyle={BUTTON_MODAL_STYLE_BLOG}
          lightButtonStyle={BUTTON_LIGHT_MODAL_STYLE_BLOG}
          sliderColor={black}
          backgroundModal={backgroundModal}
          borderImageColor={textColorDependsOnBackground}
          isTemplates
          cropper
        />
      </div>
      <div
        className="content-intro"
        style={{ backgroundColor: backgroundContent }}
      >
        <div className="textarea-blog">
          <Textarea
            onChange={handleInputSubmit}
            value={title}
            delay={TEXTAREA_DELAY}
            placeholder={portfolio.introduction.projectName}
            className="textarea-blogFriendly textarea-blogFriendly-name title custom-font-title"
            style={{
              color: textColorDependsOnBackground,
            }}
            disabled={disabled}
          />
        </div>
        <div className="textarea-blog">
          <Textarea
            onChange={handleDescriptionSubmit}
            value={description}
            delay={TEXTAREA_DELAY}
            placeholder={portfolio.introduction.projectNamePlaceholder}
            className="textarea-blogFriendly textarea-blogFriendly-description description custom-font-body"
            style={{
              color: textColorDependsOnBackground,
            }}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default IntroductionBlog;
